import { navigate } from "gatsby"
import { useCallback } from "react"
import { useInView } from "react-intersection-observer"

import { marketingClient } from "@trueskin-web/apis"
import { Button, MobileStickyCta } from "@trueskin-web/components"
import { Routes, Trans, useTranslation } from "@trueskin-web/translations"

import Card from "./card"

const Checkout = () => {
  const { t } = useTranslation()

  const [inViewRef, isInView] = useInView()

  const handleClick = useCallback(() => {
    marketingClient.trackEvent({
      name: marketingClient.EVENT_TYPES_ENUM
        .WELCOME_BACK_PAGE_PAYMENT_CTA_CLICKED,
    })

    navigate(Routes.App.Start.Payment.url)
  }, [])

  return (
    <>
      <Card
        title={t("Start.WelcomeBack.Steps.Checkout.title")}
        status="current"
        dataTestId="wb-steps-checkout"
      >
        <div sx={{ pr: 6, mb: 4 }}>
          <Trans i18nKey="Start.WelcomeBack.Steps.Checkout.description" />
        </div>
        <Button
          rounded
          isFullWidth
          onClick={handleClick}
          ref={inViewRef}
          data-testid="wb-steps-checkout-button"
        >
          {t("Start.WelcomeBack.Steps.Checkout.buttonText")}
        </Button>
      </Card>

      <MobileStickyCta
        title={t("Start.WelcomeBack.Steps.buttonText")}
        show={!isInView}
        rounded
        onClick={handleClick}
        dataTestId="wb-payment-link"
        sx={{ borderTop: "1px", borderColor: "grey", zIndex: 9 }}
      />
    </>
  )
}

export default Checkout
